import { auth } from '@/http';
import services from '@/http';
import { hasError } from "@/utils/helpers";
import * as types from './mutation-types';
import * as storage from '../storage';

export const ActionSendPromoCode = (context, payload) => {
    auth.sendPromoCode.data = payload;
    return services.http.request(auth.sendPromoCode)
        .then((result) => {
            return result;
        })
        .catch((err) => {
            return err;
        });
}

// export const ActionGetMailingFirstName = async (_, payload, code) => {
//     auth.getMailingFirstName.data = payload;
//     auth.getMailingFirstName.url = auth.getMailingFirstName.url.replace('{code}',code);
//     return services.http.request(auth.getMailingFirstName)
//                 .then((result) => {
//                     return result;
//                 })
//                 .catch((err) => {
//                     return err;
//                 });
// }

export const ActionGetMailingFirstName = async (context, payload) => {
    auth.getMailingFirstName.data = payload;
    
    // Retry logic com backoff exponencial para lidar com 401 intermitente
    const maxRetries = 3;
    const baseDelay = 1000; // 1 segundo
    let lastError = null;
    
    for (let attempt = 0; attempt <= maxRetries; attempt++) {
        try {
            const result = await services.http.request(auth.getMailingFirstName);
            return result;
        } catch (error) {
            lastError = error;
            const is401Error = error?.status === 401 || error?.response?.status === 401;
            const isLastAttempt = attempt === maxRetries;
            
            // Se for 401 e não for a última tentativa, aguarda e tenta novamente
            if (is401Error && !isLastAttempt) {
                const delay = baseDelay * Math.pow(2, attempt); // Backoff exponencial: 1s, 2s, 4s
                console.warn(`[ActionGetMailingFirstName] Tentativa ${attempt + 1}/${maxRetries + 1} falhou com 401. Tentando novamente em ${delay}ms...`);
                await new Promise(resolve => setTimeout(resolve, delay));
                // Continua para próxima iteração do loop
            } else {
                // Se não for 401 ou se for a última tentativa, para o loop
                break;
            }
        }
    }
    
    // Se chegou aqui, todas as tentativas falharam
    return Promise.reject(lastError);
}

export const ActionGetContactsByDocNumber = (context, payload) => {
    auth.getContacts.data = payload;
    return services.http.request(auth.getContacts)
        .then((result) => {
            return result;
        }).catch((err) => {
            return err;
        });
}

export const ActionCreateDebtor = (context, payload) => {
    auth.insertDebtor.data = payload;
    return services.http.request(auth.insertDebtor);
}

export const ActionIsHomolog = () => {
    return process.env.VUE_APP_HOMOLOG;
}
export const ActionDoRegisterSession = () => {
    // registra CSRF Cookies
    return services.http.request(auth.registerCookie);
}

export const ActionMailingDoLogin = async ({ dispatch }, payload) => {
    //dispatch('ActionSetLoading', true);
    auth.mailinglogin.data = payload;
    await services.http.request(auth.mailinglogin)
        .then(async response => {
            dispatch("ActionSetGuest", { value: "isNotGuest" });
            dispatch("ActionSetToken", response.data.token);
            dispatch("ActionSetTag", response.data.tag);


            await services.http.request(auth.getUser)
                .then(response => {
                    //eslint-disable-next-line
                    dispatch('ActionSetUser', response.data.results);
                    //dispatch('ActionSetLoading', false);
                })
                .catch(error => {
                    dispatch('ActionSetError', hasError(error));
                });
        })
        .catch((error) => {
            dispatch('ActionSetError', hasError(error));
            //dispatch('ActionSetLoading', false);
            throw error;
        });
}

export const ActionDoLogin = async ({ dispatch }, payload) => {
    //dispatch('ActionSetLoading', true);
    // auth.getUser.data.insertLogControl = localStorage.getItem('authLogControl');
    auth.login.data = payload;
    await services.http.request(auth.login)
        .then(async response => {
            dispatch("ActionSetGuest", { value: "isNotGuest" });
            dispatch("ActionSetToken", response.data.token);
            dispatch("ActionSetTag", "Padrao");

            await services.http.request(auth.getUser)
                .then(response => {
                    dispatch('ActionSetUser', response.data.results);
                    //dispatch('ActionSetLoading', false);
                })
                .catch(error => {
                    dispatch('ActionSetError', hasError(error));
                });
        })
        .catch((error) => {
            dispatch('ActionSetError', hasError(error));
            //dispatch('ActionSetLoading', false);
            throw error;
        });
}

export const ActionGenericDoLogin = async ({ dispatch }, payload) => {
    //dispatch('ActionSetLoading', true);
    auth.genericLogin.data = payload;
    await services.http.request(auth.genericLogin)
        .then(async response => {
            dispatch("ActionSetGuest", { value: "isNotGuest" });
            dispatch("ActionSetToken", response.data.results.token);
            dispatch("ActionSetTag", response.data.results.tag);

            console.log('response' + JSON.stringify(response));

            // eslint-disable-next-line
            // debugger

            await services.http.request(auth.getUser)
                .then(response => {
                    dispatch('ActionSetUser', response.data.results);
                    //dispatch('ActionSetLoading', false);
                })
                .catch(error => {
                    dispatch('ActionSetError', hasError(error));
                });
        })
        .catch((error) => {
            dispatch('ActionSetError', hasError(error));
            //dispatch('ActionSetLoading', false);
            throw error;
        });
}

export const ActionGetUser = async ({ dispatch }) => {

    const user = localStorage.getItem('authUser');

    if (user) {
        dispatch('ActionSetUser', JSON.parse(user));
        dispatch('ActionSetLoading', false);
        return;
    }

    return await services.http.request(auth.getUser)
        .then(response => {
            dispatch('ActionSetUser', response.data.results);
            dispatch('ActionSetLoading', false);
        })
        .catch(error => {
            dispatch('ActionSetError', hasError(error));
        });
}

export const ActionDoLogout = ({ dispatch, commit }) => {
    storage.setHeaderToken('');
    dispatch('ActionSetUser', null);
    dispatch('ActionSetToken', null);

    dispatch('negotiation/ActionNegotiationResetSession', null, { root: true });

    try {
        window.localStorage.clear();
        window.sessionStorage.clear();
    } catch (e) {
        /* quota / modo privado */
    }

    try {
        window.localStorage.setItem('guest', 'isGuest');
    } catch (e) {
        /* ignore */
    }

    commit('clearUser', undefined, { root: true });
};

export const ActionCheckToken = ({ dispatch, state }) => {
    dispatch('ActionSetLoading', true);
    if (state.token) {
        dispatch('ActionSetLoading', false);
        return Promise.resolve(state.token);
    }

    const token = storage.getLocalToken();

    if (!token) {
        dispatch('ActionSetLoading', false);
        return Promise.reject(hasError("Token Inválido!"));
    }

    dispatch('ActionSetToken', token);
    return dispatch('ActionGetUser');
}


export const ActionGetWhatsText = ({ dispatch }) => {
    dispatch('ActionSetLoading', true);
    return services.http.request(auth.whatsText)
        .then(response => {
            dispatch('ActionSetLoading', false);
            return response.data.results;
        })
        .catch((err) => {
            dispatch('ActionSetLoading', false);
            return err;
        });
}


export const ActionContatoWhatsapp = (_, payload) => {
    auth.contatoWhatsapp.data = payload;
    return services.http.request(auth.contatoWhatsapp)
        .then(response => {
            return response.data.results;
        }).catch((e) => {
            throw e;
        })
}

export const ActionGetLinkAccessAsDebtor = (context, payload) => {
    auth.getLinkAccess.data = payload;

    return services.http.request(auth.getLinkAccess)
        .then(response => {
            return response.data.results;
        })
        .catch((err) => {
            return err;
        });
}

export const ActionGetLinkDirectAccess = ({ dispatch }, payload) => {
    auth.getDirectLinkAccess.data = payload;

    return services.http.request(auth.getDirectLinkAccess)
        .then(async response => {
            const original = response.data.results.original;

            if (original && original.token) {
                const { token, debtor, tag } = original;

                dispatch("ActionSetToken", token);
                dispatch("ActionSetTag", tag);

                dispatch('ActionSetUser', debtor);

                // await services.http.request(auth.getUser)
                //     .then(response => {
                //         dispatch('ActionSetUser', response.data.results);
                //     })
                //     .catch(error => {
                //         dispatch('ActionSetError', hasError(error));
                //     });
                localStorage.setItem("UserID", original.userID);
                return { success: true, debtorId: debtor.DebtorID, docNumber: debtor.DocNumber, userAdmId: original.userID };
            } else if (original.userSiscobra) {
                console.log('original' + JSON.stringify(original));
                localStorage.setItem("userSiscobra", true);
                localStorage.setItem("tag", original.tag);
                localStorage.setItem("advisory", original.advisory);
                localStorage.setItem("UserID", original.userID);
                
                // Definir token mesmo para usuários Siscobra
                if (original.token) {
                    dispatch("ActionSetToken", original.token);
                    dispatch("ActionSetTag", original.tag);
                }
                
                const debtor = original.debtor;
                dispatch('ActionSetUser', debtor);
                
                return { success: true, debtorId: debtor.DebtorID, userAdmId: original.userID, FullName: original.fullName, userSiscobra: true, advisory: original.advisory };
            }

            return { message: original.message, result: response.data.results };
        })
        .catch((err) => {
            console.log('err', err);
            return err;
        });
}

export const ActionAuthenticateSiscobra = ({ dispatch }, payload) => {
    auth.authenticateSiscobra.data = payload;

    return services.http.request(auth.authenticateSiscobra)
        .then(async response => {
            const original = response.data.results.original;
            if (original && original.token) {
                const { token, debtor, tag } = original;

                dispatch("ActionSetToken", token);
                dispatch("ActionSetTag", tag);

                dispatch('ActionSetUser', debtor);

                // await services.http.request(auth.getUser)
                //     .then(response => {
                //         dispatch('ActionSetUser', response.data.results);
                //     })
                //     .catch(error => {
                //         dispatch('ActionSetError', hasError(error));
                //     });

                return { success: true, debtorId: debtor.DebtorID, docNumber: debtor.DocNumber, userAdmId: original.userID };
            } else if (original.userSiscobra) {
                localStorage.setItem("tag", original.tag);
                localStorage.setItem("advisory", original.advisory);
                localStorage.setItem("UserID", original.userID);
                
                // Definir token mesmo para usuários Siscobra
                if (original.token) {
                    console.log('ActionAuthenticateSiscobra: Definindo token para usuário Siscobra:', original.token);
                    console.log('ActionAuthenticateSiscobra: Formato do token Siscobra - Length:', original.token.length, 'Starts with:', original.token.substring(0, 10));
                    dispatch("ActionSetToken", original.token);
                    dispatch("ActionSetTag", original.tag);
                } else {
                    console.log('ActionAuthenticateSiscobra: ATENÇÃO - Usuário Siscobra sem token!', original);
                }
                
                const debtor = original.debtor;
                dispatch('ActionSetUser', debtor);
                
                return { success: true, debtorId: debtor.DebtorID, userAdmId: original.userID, userSiscobra: true };
            }

            return { message: original.message, result: response.data.results };
        })
        .catch((err) => {
            console.log('err', err);
            return err;
        });
}


export const ActionSetUser = ({ commit }, user) => {
    commit(types.SET_USER, user);
}

export const ActionSetLoading = ({ commit }, loading) => {
    commit(types.SET_LOADING, loading);
}

export const ActionSetError = ({ commit }, error) => {
    commit(types.SET_ERROR, error);
}

export const ActionSetCurrentForm = ({ commit }, currentForm) => {
    commit(types.SET_CURRENTFORM, currentForm);
}

export const ActionSetContacts = ({ commit }, contacts) => {
    commit(types.SET_CONTACTS, contacts);
}

export const ActionSetWhatsText = ({ commit }, text) => {
    commit(types.SET_WHATSTEXT, text);
}

export const ActionSetGuest = (context, { value }) => {
    window.localStorage.setItem("guest", value);
}

export const ActionSetToken = ({ commit }, token) => {
    console.log('ActionSetToken: Definindo token no store:', token ? token.substring(0, 20) + '...' : 'null');
    storage.setLocalToken(token);
    storage.setHeaderToken(token);
    commit(types.SET_TOKEN, token);
    console.log('ActionSetToken: Token definido com sucesso no store e localStorage');
}

export const ActionSetTag = (context, tag) => {
    window.localStorage.setItem('tag', tag);
}

export const isGuest = () => {
    const storageItem = window.localStorage.getItem("guest");
    if (!storageItem) return false;
    if (storageItem === "isGuest") return true;
    if (storageItem === "isNotGuest") return false;
}